import type { GeoJSON } from "geojson";
/*
 * Currently, non-MultiPolygon GeoJSON inputs are converted to MultiPolygon before saving.
 * However, the conversion logic has issues, causing failures when validated against
 * open-source validators that adhere to the GeoJSON specification.
 *
 * For instance, the following error may occur:
 * "First and last positions of a Polygon or MultiPolygon’s ring should be the same."
 *
 * While the GeoJSON can still be rendered on the map, it may lead to inaccuracies
 * or invalid GeoJSON data in certain scenarios.
 *
 * To address this, the logic for converting to MultiPolygon has been revised,
 * and the validator has been replaced with a robust open-source implementation.
 */
export const isValidGeoJson = (value: string): boolean => {
  const validTypes = [
    "Point",
    "MultiPoint",
    "LineString",
    "MultiLineString",
    "Polygon",
    "MultiPolygon",
    "GeometryCollection",
    "Feature",
    "FeatureCollection",
  ];

  let parsed: GeoJSON;
  try {
    parsed = JSON.parse(value) as GeoJSON;
  } catch {
    return false;
  }

  return !(
    !parsed.type ||
    !validTypes.includes(parsed.type) ||
    (parsed.type === "Feature" && !parsed.geometry) ||
    (parsed.type === "FeatureCollection" && !Array.isArray(parsed.features))
  );
};
